import appService from 'services/common';

const getRounds = (showEnded?: boolean) => {
  return appService.get(showEnded ? 'rounds?showEnded=true' : '/rounds');
};

export { getRounds };
